import { useQuery } from "@tanstack/react-query";
import { UserInfo } from "../../types";
import { loginService } from "../../services/loginService";

const normalizeEmail = (value: string): string => {
  return value.trim().toLowerCase();
};

const deriveNamesFromEmail = (email: string): Pick<UserInfo, "firstName" | "lastName"> => {
  const local = email.split("@")[0]?.trim() ?? "";
  if (!local) {
    return { firstName: "", lastName: "" };
  }

  const chunks = local
    .split(/[._-]+/)
    .map((chunk) => chunk.trim())
    .filter((chunk) => chunk.length > 0);

  const toTitleCase = (value: string): string =>
    `${value.charAt(0).toUpperCase()}${value.slice(1)}`;

  if (chunks.length === 0) {
    return { firstName: "", lastName: "" };
  }

  return {
    firstName: toTitleCase(chunks[0]),
    lastName: chunks.length > 1 ? toTitleCase(chunks[chunks.length - 1]) : "",
  };
};

export const useCurrentUser = () => {
  return useQuery<UserInfo>({
    queryKey: ["user"],
    queryFn: async () => {
      const email = normalizeEmail(loginService.getCachedSubject() ?? "user@test.com");
      const names = deriveNamesFromEmail(email);
      return {
        id: email,
        email,
        firstName: names.firstName,
        lastName: names.lastName,
        role: "admin",
        status: "confirmed",
      };
    },
  });
};
